import React, { useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useIntl } from 'react-intl';
import { WarehouseProductCardListProps } from './types';
import {
  ProductsPlaceholderWrapper,
  StyledWarehouseProductCardList,
  StyledWarehouseProductCardListItem,
} from './styles';
import WarehouseProductCard from '../WarehouseProductCard';
import { StyledBox } from '../../styles/Grid/styles';
import Spinner from '../../atoms/Spinner';
import { SpinnerMode } from '../../atoms/Spinner/enums';
import Placeholder from '../Placeholder';

const WarehouseProductCardList: React.FC<WarehouseProductCardListProps> = ({
  items,
  isHorizontal,
  hasMore,
  fetchMoreData,
  refetch,
}) => {
  const handleFetchMoreData = useCallback(() => {
    fetchMoreData();
  }, [fetchMoreData]);
  const noData = items.length === 0;
  const intl = useIntl();

  return (
    <>
      {noData ? (
        <ProductsPlaceholderWrapper>
          <Placeholder
            title={intl.formatMessage({
              id: 'warehouse.noResults',
              defaultMessage: 'No results',
            })}
          />
        </ProductsPlaceholderWrapper>
      ) : null}

      <InfiniteScroll
        style={{ overflow: 'hidden' }}
        dataLength={items.length}
        next={handleFetchMoreData}
        loader={
          <StyledBox justifyContent='center' alignItems='center' p='2rem'>
            <Spinner mode={SpinnerMode.Dark} />
          </StyledBox>
        }
        hasChildren
        scrollableTarget='main-content'
        {...{ hasMore }}
      >
        {isHorizontal && items.length > 0 && (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '56px minmax(0, 2fr) 72px 80px 80px 96px 100px auto',
              columnGap: '1.25rem',
              padding: '0 0.75rem',
              marginBottom: '0.375rem',
              color: 'var(--muted)',
              fontSize: 'var(--t-xs)',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
            }}
          >
            <span style={{ gridColumn: 'span 2' }}>Product</span>
            <span>Ordered</span>
            <span>Remaining</span>
            <span>Damaged</span>
            <span>Created</span>
            <span>Price</span>
            <div />
          </div>
        )}
        <StyledWarehouseProductCardList {...{ isHorizontal }}>
          {items.map((item) => (
            <StyledWarehouseProductCardListItem
              {...{ key: item.productId, isHorizontal }}
            >
              <WarehouseProductCard
                {...{ isHorizontal, ...item }}
                refetchProducts={refetch}
              />
            </StyledWarehouseProductCardListItem>
          ))}
        </StyledWarehouseProductCardList>
      </InfiniteScroll>
    </>
  );
};

export default WarehouseProductCardList;
